// client/src/config/api.js
// Centralized API configuration that works everywhere

/**
 * Get the API base URL based on environment
 * This function automatically detects the right URL to use
 */
export const getApiBaseUrl = () => {
  // 1. Check if environment variable is set
  if (process.env.REACT_APP_API_URL) {
    // Remove trailing slash and /api if present
    const url = process.env.REACT_APP_API_URL.replace(/\/$/, '').replace(/\/api$/, '');
    return url;
  }
  
  // 2. Production build - use relative paths (same domain)
  if (process.env.NODE_ENV === 'production') {
    // When deployed, API is on same domain
    // e.g., https://yourdomain.com/api
    return window.location.origin;
  }
  
  // 3. Development - use proxy (setupProxy.js handles routing)
  // Proxy forwards /api requests to http://localhost:5000
  return '';
};

// Export the base URL
export const API_BASE_URL = getApiBaseUrl();

// Export the full API URL with /api path
export const API_URL = API_BASE_URL ? `${API_BASE_URL}/api` : '/api';

// Helper function for constructing full URLs
export const getFullUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${cleanPath}`;
};

// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Configuration:');
  console.log('  - Base URL:', API_BASE_URL || '(using proxy)');
  console.log('  - API URL:', API_URL);
  console.log('  - Environment:', process.env.NODE_ENV);
}